import { goToLink } from "@actions/common";
import { showAlert as showAlertAction } from "@components/alert/action";
import playIcon from "@layouts/assets/images/play_icon.svg";
import { BettoExploreGameCardWrap } from "@pages/casino/containers/BettoSearchModal/elements";
import { openGame } from "@pages/casino/utils";
import { BettoFavoriteIcon } from "@pages/casino/pages/gameplay/betto/BettoGameplayIcons.jsx";
import {
	getBettoGameCardAspectRatio,
	getImageSrc,
	handleBettoGameImageError,
} from "@pages/home/betto/casinoGridSlider/gameCard.jsx";
import { getBettoImageLoadingProps } from "@pages/home/betto/utils";
import {
	CardGameName,
	CardHoverOverlay,
	CardImage,
	CardPlayIcon,
} from "@pages/home/betto/casinoSlider/elements";
import React, { memo, useCallback } from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";

const RemoveButton = styled.button`
	position: absolute;
	top: 8px;
	right: 8px;
	z-index: 4;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 28px;
	height: 28px;
	padding: 0;
	border: none;
	border-radius: 8px;
	background: rgba(10, 14, 26, 0.72);
	color: #479afe;
	cursor: pointer;
	transition:
		background 0.15s ease,
		transform 0.15s ease;

	&:hover {
		background: rgba(10, 14, 26, 0.9);
		transform: scale(1.05);
	}
`;

export const BettoFavoriteGameCard = memo(({ game, imageIndex, onRemoveFavorite }) => {
	const dispatch = useDispatch();
	const imageLoadingProps = getBettoImageLoadingProps(imageIndex);

	const handleClick = useCallback(() => {
		const redirect = (...args) => dispatch(goToLink(...args));
		const showAlert = (...args) => dispatch(showAlertAction(...args));
		const type = game?.is_live ? "LiveCasino" : "Casino";

		const { pathname, search } = window.location;
		localStorage.setItem("casino.basePath", `${pathname}${search}`);
		openGame(game, redirect, showAlert, {}, type);

		window?.dataLayer?.push({
			event: "casino-game-card-click",
			gameName: game?.remote_name,
			gameId: game?.game_id,
			gameAffiliate: game?.affiliate,
			gameProvider: game?.provider,
			is_live: game?.is_live,
		});
	}, [game, dispatch]);

	const handleRemove = useCallback(
		(event) => {
			event.stopPropagation();
			onRemoveFavorite?.(game?.id);
		},
		[game?.id, onRemoveFavorite]
	);

	const handleImageError = useCallback(
		(event) => {
			handleBettoGameImageError(event, game);
		},
		[game]
	);

	return (
		<BettoExploreGameCardWrap
			$aspectRatio={getBettoGameCardAspectRatio(game)}
			onClick={handleClick}>
			<RemoveButton
				type="button"
				aria-label="Remove from favorites"
				onClick={handleRemove}>
				<BettoFavoriteIcon filled />
			</RemoveButton>
			<CardImage
				src={getImageSrc(game)}
				alt={game?.remote_name || ""}
				{...imageLoadingProps}
				onError={handleImageError}
			/>
			<CardHoverOverlay onClick={handleClick}>
				<CardGameName>{game?.remote_name}</CardGameName>
				<CardPlayIcon
					src={playIcon}
					alt=""
				/>
			</CardHoverOverlay>
		</BettoExploreGameCardWrap>
	);
});

BettoFavoriteGameCard.displayName = "BettoFavoriteGameCard";

export default BettoFavoriteGameCard;
